<template>
  <div class="shinetop">
    <div class="inputGroup">
      <div :v-if="calssList.length" class="search">
        <el-select v-model="choose" placeholder="Product Categories"  class="input1">
          <el-option
            v-for="item in calssList"
            :key="item.url"
            :label="item.class_name_en"
            :value="item.id">
          </el-option>
        </el-select>
        <el-input v-model="product" placeholder="Search Products" class="input2"></el-input>
        <el-button class="searchFillet" icon="el-icon-search" @click="searchSelect"></el-button>
      </div>
      <div class="search">
        <el-input v-model="merchant" placeholder="Search Exhibitors"></el-input>
        <el-button class="searchFillet" icon="el-icon-search" @click="seachInput(true)"></el-button>
      </div>
    </div>
    <div class="booth_figure">
      <div class="f_l">
        <div>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/bg_en.png" />
          <div class="f_l_position">
            <img 
              :class="activeIndex == 'E1' ? 'opacity1' : ''" 
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/E1.png"
              alt="天然气"
            />
            <img
              :class="activeIndex == 'E2' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/E2.png"
              alt="氢能源"
            />
            <img
              :class="activeIndex == 'E3' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/E3.png"
              alt="管道与存储"
            />
            <img
              :class="activeIndex == 'E4' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/E4.png"
              alt="燃气技术"
            />
            <img
              :class="activeIndex == 'W1' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/W1.png"
              alt="非开挖技术"
            />
            <img
              :class="activeIndex == 'W2' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/W2.png"
              alt="防爆与仪器仪表"
            />
            <img
              :class="activeIndex == 'W3' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/W3.png"
              alt="国际展团、德国展团"
            />
            <img
              :class="activeIndex == 'W4' ? 'opacity1' : ''"
              src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/W4.png"
              alt="页岩气"
            />
          </div>
          <div class="f_l_text">
            <dl class="W W4">
              <dd>Industrial Hydrogen Production /</dd>
              <dd>Hydrogen Refueling /</dd>
              <dd>Hydrogen Storage and Transport /</dd>
              <dd>Instrumentation / Security</dd>
            </dl>
            <dl class="W W3">
              <dd>Pipeline / Fluid Machinery /</dd>
              <dd>Trenchless</dd>
            </dl>
            <dl class="W W2">
              <dd>International Exhibitors /</dd>
              <dd>Marine Engineering /</dd>
              <dd>Offshore Oil & Gas</dd>
            </dl>
            <dl class="W W1">
              <dd>Hall for International </dd>
              <dd>Exhibitors &National</dd>
              <dd>Pavilions / ROV /</dd>
              <dd>Offshore Wind Power</dd>
            </dl>
            <dl class="E E4">
              <dd>Natural Gas / City Gas / </dd>
              <dd>Explosion-proof / Safety</dd>
            </dl>
            <dl class="E E3">
              <dd>Exploration and </dd>
              <dd>Production Equipment</dd>
            </dl>
            <dl class="E E2">
              <dd>SINOPEC Pavilion. Exploration /</dd>
              <dd>Drilling Equipment</dd>
            </dl>
            <dl class="E E1">
              <dd>CNPC Pavilion / Exploration /</dd>
              <dd>Drilling Equipment</dd>
            </dl>
          </div>
          <div class="hot">
            <span class="w4" @click="shiJump('W4')"><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/home_hot_bg.png" alt=""/></span>
            <span class="w3" @click="shiJump('W3')"><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/home_hot_bg.png" alt=""/></span>
            <span class="w2" @click="shiJump('W2')"><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/home_hot_bg.png" alt=""/></span>
            <span class="w1" @click="shiJump('W1')"><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/home_hot_bg.png" alt=""/></span>
            <span class="e4" @click="shiJump('E4')"><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/home_hot_bg.png" alt=""/></span>
            <span class="e3" @click="shiJump('E3')"><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/home_hot_bg.png" alt=""/></span>
            <span class="e2" @click="shiJump('E2')"><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/home_hot_bg.png" alt=""/></span>
            <span class="e1" @click="shiJump('E1')"><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/home_hot_bg.png" alt=""/></span>
          </div>
        </div>
        <div>
          <img style="opacity:0" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_E1_en.png"/>
          <div class="f_l_position zgt">
            <div class="f_l_position zgt">
              <img
                :class="activeIndex == 'W1' ? 'opacity1' : ''"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_W1_en.png"
                alt="W1"
              />
              <img
                :class="activeIndex == 'W2' ? 'opacity1' : ''"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_W2_en.png"
                alt="W2"
              />
              <img
                :class="activeIndex == 'W3' ? 'opacity1' : ''"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_W3_en.png"
                alt="W3"
              />
              <img
                :class="activeIndex == 'W4' ? 'opacity1' : ''"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_W4_en.png"
                alt="W4"
              />
              <img
                :class="activeIndex == 'E1' ? 'opacity1' : ''"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_E1_en.png"
                alt="E1"
              />
              <img
                :class="activeIndex == 'E2' ? 'opacity1' : ''"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_E2_en.png"
                alt="E2"
              />
              <img
                :class="activeIndex == 'E3' ? 'opacity1' : ''"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_E3_en.png"
                alt="E3"
              />
              <img
                :class="activeIndex == 'E4' ? 'opacity1' : ''"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/2022/zgxgqy_E4_en.png"
                alt="E4"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="f_r">
        <ul>
          <li :class="activeIndex== item.url ? 'li_item li_item_active':'li_item'" v-for="(item,i) in list" :key="i" @mouseover="activeMove(item.url)" @click="shiJump(item.url)">
            <div>
              <p><span v-for="(value,j) in item.arr_en" :key="j+'item'" >
                {{value}}
              </span></p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { reqSortList } from "../../../api";
export default {
  data(){
    return{
      choose:'',//展品分类选择
      product:"",//展品名称
      merchant:"",//展商名称
      calssList:[],//数据
      opacit:'w1',//当前选择
      list:[{
        arr_en:['Industrial Hydrogen Production /', 'Hydrogen Refueling / Hydrogen Storage and', 'Transport / Instrumentation / Security'],
        url:'W4'
      },
      {
        arr_en:['Natural Gas / City Gas /', 'Explosion-proof / Safety'],
        url:'E4'
      },
      {
        arr_en:['Pipeline / Fluid Machinery / Trenchless'],
        url:'W3'
      },
      {
        arr_en:['Exploration and Production Equipment'],
        url:'E3'
      },
      {
        arr_en:['International Exhibitors /', 'Marine Engineering/Offshore Oil & Gas'],
        url:'W2'
      },
      {
        arr_en:['SINOPEC Pavilion. Exploration /', 'Drilling Equipment'],
        url:'E2'
      },
      {
        arr_en:['Hall for International Exhibitors &National', 'Pavilions / ROV / Offshore Wind Power'],
        url:'W1'
      },
      {
        arr_en:['CNPC Pavilion / Exploration /', 'Drilling Equipment'],
        url:'E1'
      }],
      pavilionList:[
        {
          title:'E1馆',
          title_en:'E1馆',
          arr:['zgxgqy_W2.png',],
        }
      ],
      activeIndex:0//高亮
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    activeMove(i){
      this.activeIndex = i
    },
    async init(){// 获取展品分类
      const response = await reqSortList()
      if (response.code==0) {
        this.calssList = [{url:0,class_name_cn:"全部",class_name_en:'All',id:0},...response.resilt]
      }
    },

    searchSelect(){// 展品选择搜索
      // let barList = [...this.calssList]
      let choose = this.choose
      let product = this.product
      sessionStorage.setItem('goodsData',JSON.stringify({choose,product}))
      this.$router.push("/exhibit")
    },
    
    seachInput(){// 展商搜索
      let value = this.merchant
      sessionStorage.setItem('merchant',JSON.stringify(value))
      this.$router.push("/exhibitor")
    },
    shiJump(value){//跳转
      sessionStorage.setItem('pavilion',JSON.stringify(value))
      this.$router.push("/exhibitor")
    }
  },
  computed:{
    activeNape:(i)=>{
      console.log(i,123);
      return 1
    }
  }
}
</script>

<style scoped>
  .inputGroup{
    display: flex;
    justify-content: space-between;
    padding-top: 43px;
    padding-bottom: 60px;
    max-width: 800px;
    margin: 0 auto;
    width: 100%;
    z-index: 1;
  }
  .inputGroup >div{
    width: 46%;
  }
  .el-select{
    height: 40px;
    width: 28%;
    border-right: none;
  }
  .query>>>.el-input__inner,
  .query>>>.el-select-dropdown__item{
    color: #333;
  }
  .search >>>.el-input__inner{
    height: 40px ;
    padding:0  20px;
    border-radius: 40px 0 0 40px;
    font-size: 12px;
    border-right: none;
  }
  .el-input{
    width: 80%;
  }
  .search .input1>>>.el-input__inner{
    color: white;
    background-color: #f08300;
  }
  .search .input1>>>.el-input__icon{
    width: 14px;
    color: white;
    line-height: 40px;
  }
   .search .input2{
     width: 58%;
   }
  .search .input2>>>.el-input__inner{
    border-radius: 0;
  }
  .search .el-button{
    height: 40px;
    width: 14%;
    border-left: none;
    padding: 6px 14px 6px 8px;
    font-size: 20px;
    background-color: #f5f7fa;
    color: #037d9d;
    border-radius: 0 40px 40px 0;
    vertical-align: top;
  }
   .search >>>.el-input__inner:focus,
   .search >>>.el-button:focus{
    border-color: #8b8e94;
  }
  
 .search>>>.el-select-dropdown__item{
   font-size: 12px;
 }

  /deep/.input1 input::-webkit-input-placeholder {
    color: #fff;
  }
  /deep/.input1 input::-moz-input-placeholder {
    color: #fff;
  }
  /deep/.input1 input::-ms-input-placeholder {
    color: #fff;
  }
  .navImg{
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
<style scoped>
.shinetop{
  /* height: 100%; */
  /* height: 886px; */
  background-image: url('https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/pmt/nav_bg.jpg');
  background-size:  auto 100%;
  background-position: center;
  padding-bottom: 50px;
}
.booth_figure{
  margin-left: -100%;
  height: 100%;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.f_l{
  
  display: inline-block;
  width: 58%;
  max-width: 658px;
  /* height: 400px; */
  /* background-color: seagreen; */
  vertical-align: top;
}
.f_l>div{
  position: relative;
  width: 100%;
}

.f_l_position{
  width: 100%;
  overflow: visible;
  position: absolute;
  left: 0px;
  top: 0px;
  height: 100%;
}
.f_l_position img{
  position: absolute;
  left: 0;
  top: 0;
  height: auto;
  opacity: 0;
  transition: all .5s;
}
.f_l_text{
  position: absolute;
  left: 118px;
  right: 128px;
  top: 27px;
  bottom: 83px;
  font-size: 12px;
}
.f_l_text .W{
  position: absolute;
  left: 0;
  width: 182px;
  height: 97px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  zoom: .8;
}
.f_l_text .E{
  position: absolute;
  right: 0;
  width: 182px;
  height: 97px;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  zoom: .8;
}
.f_l_text .W3,
.f_l_text .E3{
  top: 144px;
}
.f_l_text .W2,
.f_l_text .E2{
  top: 260px;
}
.f_l_text .W1,
.f_l_text .E1{
  bottom: 0;
}

/* 热点覆盖 start */
.hot{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.hot span{
  position: absolute;
  display: inline-block;
  /* width: 184px; */
  width: 26.43%;
  /* height: 80px; */
  cursor: pointer;
}
.hot .w4{
  left: 13.8%;
  top: 5.5%;
}
.hot .w3{
  left: 13.8%;
  top: 28.5%;
}
.hot .w2{
  left: 13.8%;
  top: 46.5%;
}
.hot .w1{
  left: 13.8%;
  top: 68.5%;
}
.hot .e4{
  left: 54%;
  top: 6.3%;
}
.hot .e3{
  left: 54%;
  top: 28.5%;
}
.hot .e2{
  left: 54%;
  top: 46.5%;
}
.hot .e1{
  left: 54%;
  top: 68.5%;
}

/* 热点覆盖 start */

.zgt img{
  width: 100%;
  transition: all 0s;
}
.f_l .opacity1{
  opacity: 1;
}
.f_r{
  display: inline-block;
  width: 42%;
  max-width: calc(100% - 658px);
  padding-top: 20px;
  /* background-color: pink; */
}
.f_r > ul{
  width: 94%;
  margin-left: auto;
  margin-right: 0;
  text-align: center;
  font-family: 'FjallaOne-Regular';
}
.li_item{
  display: inline-block;
  width: calc(50% - 6px);
  height: 92px;
  min-height: 92px;
  margin-left: 6px;
  margin-bottom: 14px;
  background-color: #20adb8;
  vertical-align: top;
  cursor: pointer;
  user-select: none;
  transition: all .3s;
}
.li_item:nth-child(4n-1),
.li_item:nth-child(4n){
  background-color: #04999e;
}
.li_item:hover,
.f_r .li_item_active{
  /* background-color: #f08300; */
  background-color: #cba441;
}
.li_item>div{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.li_item span{
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: white;
  line-height: 18px;
}
@media (min-width: 768px) and (max-width: 900px) {
  .li_item span{
    font-size: 14px;
    line-height: 16px;
  }
}

</style>